<template>
  <div>
    <ConfirmationDialog2 ref="confirmationDialog" />
    <slot :submit="submit" :loading="loading" />
    <ExecutionResultsDialog @close="$emit('reload')" ref="executionResultsDialog">
      <template #title="{ isError }">
        <span v-if="isError">
          <v-icon class="mr-1" large color="warning">error</v-icon>
          Failed to detect file type
        </span>
        <span v-else>
          <v-icon class="mr-1" large color="success">check_circle</v-icon>
          File type detected successfully
        </span>
      </template>
      <template #actions="{ FileResults }">
        <ul v-if="FileResults && FileResults.length > 0">
          <li class="pb-2">
            <router-link :to="{ name: 'dataset', params: {id: FileResults[0].FileId }}">Continue to the file</router-link>.
          </li>
          <li class="pb-2">
            <router-link :to="{ name: 'dataset', params: {id: FileResults[0].FileId }}">Review the file</router-link> and its contents for any formatting mistakes. Reupload the file if any changes were made.
          </li>
          <li class="pb-2" v-if="isTenantAdmin">Customize the ingestion service configurations to better suit your file format.</li>
          <li class="pb-2" v-if="isTenantAdmin">
            <router-link :to="{ name: 'dataset', params: {id: FileResults[0].FileId }}">Manually set the file type</router-link> by editing the file.
          </li>
          <li class="pb-2">Contact your administrator or Hatfield if you require assistance.</li>
        </ul>
      </template>
      <template #next="{ FileResults }">
        <PrimaryBtn v-if="!noNext" color="primary" :to="{ name: 'dataset', params: {id: FileResults[0].FileId }}">
          View file
        </PrimaryBtn>
      </template>
    </ExecutionResultsDialog>
  </div>
</template>

<script>
  import { deleteConfirmParams } from '@/helpers/datasets/ingestions'
  import { createNamespacedHelpers } from 'vuex'

  const rawdatarepository = createNamespacedHelpers('rawdatarepository')
  const authenticate = createNamespacedHelpers('authenticate')
  const app = createNamespacedHelpers('app')

  export default {
    props: {
      noNext: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      loading: false,
    }),
    computed: {
      ...authenticate.mapGetters([
        'isTenantAdmin',
      ]),
    },
    watch: {
      loading: {
        deep: true,
        handler(val) {
          this.$emit('loading', val)
        },
      },
    },
    methods: {
      ...app.mapActions(['setSnackbar']),
      ...rawdatarepository.mapActions(['deleteFile']),
      async submit(rdrFileId) {        
        let confirmed = await this.$refs.confirmationDialog.confirm(deleteConfirmParams)
        if (!confirmed) return
        this.loading = true

        try {
          let res = await this.deleteFile({ fileId: rdrFileId })
          //this.$refs.executionResultsDialog.show(res)
          if(res) {
            this.setSnackbar({
              color: 'success',
              text: 'File deleted.',
            })
          } else {
            this.setSnackbar({
              color: 'error',
              text: 'File deleted fails.',
            })
          }
          
        } catch (err) {
          this.setSnackbar({
            color: 'error',
            text: `Failed to delete file. ${err}`,
          })
        } finally {
          this.loading = false
          this.$emit('reload')
        }
      },
    },
  }
</script>